import React, { useEffect, useRef, useState } from "react";
import {
    Accordion,
    Button,
    Carousel,
    Col,
    Container,
    Nav,
    Overlay,
    Row,
    Spinner,
    Tab,
    Table,
    Tabs,
    Tooltip, Form
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { commonservices } from "../../services/CommonServices";
import { ProjectTermGetList } from "../../services/ReduxTookit/Slice/ProjectTermRedux";
import infoIcon from "../../assets/images/infobtnblue.svg";
import SubmitLoading from "../../component/common-component/Loaders/SubmitLoading";
import { SubscribersInfrastructureAutomationSave, GetBySubscriber, Delete, GetRunningLog } from "../../services/ReduxTookit/Slice/SubscribersInfrastructureAutomation";
import verified from "../../assets/images/verified.svg";
import { HubConnectionBuilder } from "@microsoft/signalr";
import Loader, { LoaderType } from "../../component/common-component/Loader";
import Nodata from "../../component/common-component/Nodata";
import viewaction from "../../assets/images/viewaction.svg";
import deleteaction from "../../assets/images/deleteaction.svg";
import actionLog from "../../assets/images/actionLog.svg";
import DeleteModal from "../DeleteModal";
import { API_URL } from "../../services/APIRoute";

const InfrastructureAutomation = () => {
    let dispatch = useDispatch();
    const [viewMode, setViewMode] = useState("list"); // "list" | "wizard"
    const [infrastructureList, setInfrastructureList] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
    const [ActivePage, setActivePage] = useState("Prerequisites");

    const [IsViewLogScreen, setIsViewLogScreen] = useState(false);



    const [ProcessList, setProcessList] = useState([
        { "id": "vpc", "name": "VPC Network", "detail": "Virtual Private Cloud", "status": "pending" },
        { "id": "internet_gateway", "name": "Internet Gateway", "detail": "IGW for public access", "status": "pending" },
        { "id": "nat_gateway", "name": "NAT Gateway", "detail": "NAT for private subnets", "status": "pending" },
        { "id": "subnets", "name": "Subnets", "detail": "Public and Private Subnets", "status": "pending" },
        { "id": "security_groups", "name": "Security Groups", "detail": "EKS Control Plane SG", "status": "pending" },
        { "id": "iam_roles", "name": "IAM Roles", "detail": "EKS Service Role", "status": "pending" },
        { "id": "eks_cluster", "name": "EKS Cluster", "detail": "Kubernetes Control Plane", "status": "pending" },
        { "id": "eks_nodegroup", "name": "EKS Node Group", "detail": "Worker Nodes", "status": "pending" },
        { "id": "karpenter", "name": "Karpenter Installation", "detail": "Auto-scaling controller", "status": "pending" },
        { "id": "argo_workflows", "name": "Argo Workflows", "detail": "Workflow Engine", "status": "pending" },
        { "id": "load_balancer", "name": "Load Balancer", "detail": "Application Load Balancer", "status": "pending" },
        { "id": "cloudwatch", "name": "CloudWatch Logs", "detail": "Log Group Configuration", "status": "pending" },
        { "id": "ecr", "name": "ECR Repository", "detail": "Container Registry", "status": "pending" }
    ]);






    let Userdata = useSelector((state) => state.userinfo.UserInfo);
    const [InputModel, setInputModel] = useState({
        subscribersinfrastructureautomationid: 0,
        clientname: Userdata.subscribercode,
        displayname: "",
        awsclientid: "",
        environment: "prod",
        awsaccesskey: "",
        awssecretkey: "",
        awsregion: "",
        amazoneksversion: "",
        karpenterversion: "",
        argoworkflowsversion: "",
        status: "",
        errors: {
            clientname: "",
            displayname: "",
            awsclientid: "",
            environment: "",
            awsaccesskey: "",
            awssecretkey: "",
            awsregion: "",
            amazoneksversion: "",
            karpenterversion: "",
            argoworkflowsversion: "",
            ValidationRules: [
                {
                    FieldName: "clientname",
                    ValidationType: "required",
                    ValidationMessage: "This field is a required field",
                },
                {
                    FieldName: "displayname",
                    ValidationType: "required",
                    ValidationMessage: "This field is a required field",
                },
                {
                    FieldName: "awsclientid",
                    ValidationType: "required",
                    ValidationMessage: "This field is a required field",
                },
                {
                    FieldName: "environment",
                    ValidationType: "required",
                    ValidationMessage: "This field is a required field",
                },
                {
                    FieldName: "awsaccesskey",
                    ValidationType: "required",
                    ValidationMessage: "This field is a required field",
                },
                {
                    FieldName: "awssecretkey",
                    ValidationType: "required",
                    ValidationMessage: "This field is a required field",
                },
                {
                    FieldName: "argoworkflowsversion",
                    ValidationType: "required",
                    ValidationMessage: "This field is a required field",
                },
                {
                    FieldName: "karpenterversion",
                    ValidationType: "required",
                    ValidationMessage: "This field is a required field",
                },
                {
                    FieldName: "amazoneksversion",
                    ValidationType: "required",
                    ValidationMessage: "This field is a required field",
                },
                {
                    FieldName: "awsregion",
                    ValidationType: "required",
                    ValidationMessage: "This field is a required field",
                }
            ],
        }
    });

    const [ProjectTermList, setProjectTermList] = useState({
        AmazonEKSVersion: [],
        KarpenterVersion: [],
        ArgoWorkflowsVersion: [],
        AWSRegion: [],
        RequiredAWSPermissions: [],
        AWSPrerequisitesChecklist: [],
    });

    async function getProjectTermList() {
        let body = {
            term: "",
            category:
                "Amazon EKS (Kubernetes) Version,Karpenter (Auto Scaling) Version,Argo Workflows Version,AWS Region,Required AWS Permissions,AWS Prerequisites Checklist",
        };
        dispatch(ProjectTermGetList(body))?.then((response) => {
            if (response?.payload?.isValidate) {
                if (response?.payload?.data?.data?.length > 0) {

                    setProjectTermList({
                        AmazonEKSVersion: response?.payload?.data?.data.filter(
                            (f) => f.category === "Amazon EKS (Kubernetes) Version"
                        ),
                        KarpenterVersion: response?.payload?.data?.data.filter(
                            (f) => f.category === "Karpenter (Auto Scaling) Version"
                        ),
                        ArgoWorkflowsVersion: response?.payload?.data?.data.filter(
                            (f) => f.category === "Argo Workflows Version"
                        ),
                        AWSRegion: response?.payload?.data?.data.filter(
                            (f) => f.category === "AWS Region"
                        ),
                        RequiredAWSPermissions: response?.payload?.data?.data.filter(
                            (f) => f.category === "Required AWS Permissions"
                        ),
                        AWSPrerequisitesChecklist: response?.payload?.data?.data.filter(
                            (f) => f.category === "AWS Prerequisites Checklist"
                        )
                    });
                }
            }
        });
    }

    function fnCheckValidationAndGoNext(NextStep, CurrentStep) {

        let validationResult = commonservices.fnCheckValidationOfObject(InputModel);
        setInputModel({
            ...validationResult.obj,
            errors: {
                ...InputModel.errors,
                ...validationResult.obj.errors,
            },
        });

        if (!validationResult.isValid) {
            if (CurrentStep === "Client Info") {
                if (!validationResult?.obj?.errors?.clientname && !validationResult?.obj?.errors?.displayname && !validationResult?.obj?.errors?.awsclientid && !validationResult?.obj?.errors?.environment) {
                    setActivePage(NextStep)
                }
            }
            else if (CurrentStep === "AWS Creds") {
                if (!validationResult?.obj?.errors?.awsaccesskey && !validationResult?.obj?.errors?.awssecretkey && !validationResult?.obj?.errors?.awsregion) {
                    setActivePage(NextStep)
                }
            }
            else if (CurrentStep === "Versions") {
                if (!validationResult?.obj?.errors?.amazoneksversion && !validationResult?.obj?.errors?.karpenterversion && !validationResult?.obj?.errors?.argoworkflowsversion) {
                    setActivePage(NextStep)
                }
            }
            else if (CurrentStep === "Prerequisites") {
                setActivePage(NextStep)
            }
        }
        else {
            setActivePage(NextStep)
        }

    }

    const [SubmitLoader, setSubmitLoader] = useState(false);

    async function fnOnboardInfrastructure() {
        let validationResult = commonservices.fnCheckValidationOfObject(InputModel);
        setInputModel({
            ...validationResult.obj,
            errors: {
                ...InputModel.errors,
                ...validationResult.obj.errors,
            },
        });

        if (validationResult.isValid) {
            setSubmitLoader(true);
            let _data = {
                clientname: InputModel.clientname,
                displayname: InputModel.displayname,
                awsclientid: InputModel.awsclientid,
                environment: InputModel.environment,
                awsaccesskey: InputModel.awsaccesskey,
                awssecretkey: InputModel.awssecretkey,
                awsregion: InputModel.awsregion,
                amazoneksversion: InputModel.amazoneksversion,
                karpenterversion: InputModel.karpenterversion,
                argoworkflowsversion: InputModel.argoworkflowsversion
            };

            dispatch(SubscribersInfrastructureAutomationSave(_data))?.then((response) => {
                setSubmitLoader(false);
                if (response?.payload?.isValidate) {
                    setIsViewLogScreen(true);
                    let GetLogDetails = setInterval(() => {
                        clearInterval(GetLogDetails);
                        fnGetLog(response?.payload?.data?.data?.stdout)
                    }, 10000);
                }
            });
        }
    }

    const [DataLoader, setDataLoader] = useState(false);

    async function GetBySubscriberData() {
        setDataLoader(true);
        dispatch(GetBySubscriber())?.then((response) => {
            setDataLoader(false);
            if (response?.payload?.isValidate) {
                const data = response?.payload?.data?.data;
                if (Array.isArray(data)) {
                    setInfrastructureList(data);
                } else if (data && typeof data === "object") {
                    setInfrastructureList([data]);
                } else {
                    setInfrastructureList([]);
                }
            } else {
                setInfrastructureList([]);
            }
        }).catch(() => {
            setDataLoader(false);
            setInfrastructureList([]);
        });
    }

    const handleAddNew = () => {
        let _InputModel = { ...InputModel };
        _InputModel.subscribersinfrastructureautomationid = 0;
        _InputModel.clientname = Userdata.subscribercode;
        _InputModel.displayname = "";
        _InputModel.awsclientid = "";
        _InputModel.awsaccesskey = "";
        _InputModel.awssecretkey = "";
        _InputModel.awsregion = "";
        _InputModel.amazoneksversion = "";
        _InputModel.karpenterversion = "";
        _InputModel.argoworkflowsversion = "";
        _InputModel.environment = "prod";
        _InputModel.status = "";
        _InputModel.errors = {
            clientname: "",
            displayname: "",
            awsclientid: "",
            environment: "",
            awsaccesskey: "",
            awssecretkey: "",
            awsregion: "",
            amazoneksversion: "",
            karpenterversion: "",
            argoworkflowsversion: "",
            ValidationRules: InputModel.errors.ValidationRules
        };
        setInputModel(_InputModel);
        setActivePage("Prerequisites");
        setIsViewLogScreen(false);
        setViewMode("wizard");
    };

    const handleViewDetails = (item) => {
        let _InputModel = { ...InputModel };
        _InputModel.subscribersinfrastructureautomationid = item?.subscribersinfrastructureautomationid || 0;
        _InputModel.clientname = item?.clientname || Userdata.subscribercode;
        _InputModel.displayname = item?.displayname || "";
        _InputModel.awsclientid = item?.awsclientid || "";
        _InputModel.awsaccesskey = item?.awsaccesskey || "";
        _InputModel.awssecretkey = item?.awssecretkey || "";
        _InputModel.awsregion = item?.awsregion || "";
        _InputModel.amazoneksversion = item?.amazoneksversion || "";
        _InputModel.karpenterversion = item?.karpenterversion || "";
        _InputModel.argoworkflowsversion = item?.argoworkflowsversion || "";
        _InputModel.environment = item?.environment || "prod";
        _InputModel.status = item?.status || "";
        _InputModel.errors = {
            clientname: "",
            displayname: "",
            awsclientid: "",
            environment: "",
            awsaccesskey: "",
            awssecretkey: "",
            awsregion: "",
            amazoneksversion: "",
            karpenterversion: "",
            argoworkflowsversion: "",
            ValidationRules: InputModel.errors.ValidationRules
        };
        setInputModel(_InputModel);
        setActivePage("Review");
        setIsViewLogScreen(false);
        setViewMode("wizard");
    };

    const handleViewLogs = (item) => {
        setIsViewLogScreen(true);
        if (item?.stdout) {
            fnGetLog(item.stdout);
        }
    };

    const normalizeStatus = (status) => {
        if (!status) return "Pending";
        const s = status.toString().trim();
        const lower = s.toLowerCase();
        if (lower === "pendding" || lower === "pending") return "Pending";
        if (lower === "completed" || lower === "complete") return "Completed";
        if (lower === "running" || lower === "in progress" || lower === "inprocess" || lower === "in-process") return "In Progress";
        if (lower === "failed" || lower === "error") return "Failed";
        if (lower === "active" || lower === "success") return "Active";
        return s.charAt(0).toUpperCase() + s.slice(1);
    };


    async function fnOffboardInfrastructure() {
        setSubmitLoader(true);
        dispatch(Delete(InputModel.subscribersinfrastructureautomationid))?.then((response) => {
            setSubmitLoader(false);
            if (response?.payload?.isValidate) {
                setViewMode("list");
                GetBySubscriberData();
            }
        });
    }

    useEffect(() => {
        GetBySubscriberData();
        getProjectTermList();
    }, []);


    function fnGetLog(workflowname) {

        if (workflowname) {
            workflowname = workflowname.replace("workflow.argoproj.io/", "").replace("created", "").trim();

            let _data1 = {
                workflow_name: workflowname,
            };

            dispatch(GetRunningLog(_data1))?.then((response1) => {
                if (response1?.payload?.isValidate) {
                    const connect = new HubConnectionBuilder()
                        .withUrl(process.env.REACT_APP_SIGNAL_R, { withCredentials: false })
                        .withAutomaticReconnect()
                        .build();
                    connect.start().then(() => {
                        connect.send("infrastructureconnect", workflowname);
                        connect.on("getinfrastructureupdate", (data) => { fnBindLogOnUI(data); });
                    }).catch((error) => { });
                }
            });
        }
    }


    function fnBindLogOnUI(data) {
        if (data) {
            if (data.type) {
                if (data.type.toUpperCase() !== "RESOURCE_STATUS") {

                    if (data.message) {
                        let ele = document.getElementById("terminal");
                        if (ele) {
                            ele.innerHTML += '<div class="log-line"><span class="log-timestamp">[' + commonservices.getDateInFormatCustom(new Date()) + ']</span><span class="log-level log-level-' + data.type.toLowerCase() + '">[' + data.type.toUpperCase() + ']</span> ' + data.message + ' </div>';
                        }
                        toggleAutoScroll();
                    }
                }
                else if (data.type.toUpperCase() === "RESOURCE_STATUS") {
                    let _ProcessList = structuredClone(ProcessList);

                    if (data.message) {
                        let ele = document.getElementById("terminal");
                        if (ele) {
                            ele.innerHTML += '<div class="log-line"><span class="log-timestamp">[' + commonservices.getDateInFormatCustom(new Date()) + ']</span><span class="log-level log-level-' + data.data.status.toLowerCase() + '">[' + data.data.status.toUpperCase() + ']</span> ' + data.message + ' </div>';
                        }
                        toggleAutoScroll();
                    }

                    if (data.data.resource_id && data.data.status) {
                        let F = _ProcessList.filter((d) => d.id === data.data.resource_id);
                        if (F && F.length > 0) {
                            F[0].status = data.data.status.toLowerCase();
                            setProcessList(_ProcessList);
                        }
                    }
                }
            }
        }
    }

    function GetWizardProgress() {
        let per = "10%";
        let step = 1;

        if (ActivePage === "Prerequisites") {
            per = "10%";
            step = 1;
        }
        else if (ActivePage === "Client Info") {
            per = "30%";
            step = 2;
        }
        else if (ActivePage === "AWS Creds") {
            per = "50%";
            step = 3;
        }
        else if (ActivePage === "Versions") {
            per = "70%";
            step = 4;
        }
        else if (ActivePage === "Review") {
            per = "100%";
            step = 5;
        }
        return { step, per };
    }

    function copyCode(button) {
        const codeBlock = button.parentElement;
        const code = codeBlock.querySelector('code');
        const textToCopy = code.textContent;

        navigator.clipboard.writeText(textToCopy).then(() => {
            const originalText = button.textContent;
            button.textContent = 'Copied!';
            button.classList.add('copied');

            setTimeout(() => {
                button.textContent = originalText;
                button.classList.remove('copied');
            }, 2000);
        }).catch(err => {
            console.error('Failed to copy text: ', err);
            button.textContent = 'Failed';
            setTimeout(() => {
                button.textContent = 'Copy';
            }, 2000);
        });
    }

    function downloadSetupScript() {
        const scriptContent = `#!/bin/bash
            # Quantum Infrastructure Automation - Client Setup Script
            set -e

            GREEN='\\033[0;32m'
            YELLOW='\\033[1;33m'
            NC='\\033[0m'

            echo -e "\${GREEN}=== Quantum Infrastructure Automation - Client Setup ===\${NC}\\n"

            # Get AWS Account ID
            ACCOUNT_ID=$(aws sts get-caller-identity --query Account --output text)
            echo -e "\${GREEN}\${NC} AWS Account ID: \${ACCOUNT_ID}"

            # Create IAM User
            echo -e "\\n\${YELLOW}Creating IAM User: Quantum-Automation...\${NC}"
            aws iam create-user --user-name Quantum-Automation 2>/dev/null || echo -e "\${YELLOW}User already exists\${NC}"
            echo -e "\${GREEN}\${NC} IAM User created"

            # Create policy (download QuantumAutomationPolicy.json first)
            echo -e "\\n\${YELLOW}Creating IAM Policy...\${NC}"
            POLICY_ARN="arn:aws:iam::\${ACCOUNT_ID}:policy/QuantumAutomationPolicy"
            aws iam create-policy \\
              --policy-name QuantumAutomationPolicy \\
              --policy-document file://QuantumAutomationPolicy.json \\
              --description "Policy for Quantum Infrastructure Automation" 2>/dev/null || echo -e "\${YELLOW}Policy already exists\${NC}"
            echo -e "\${GREEN}\${NC} IAM Policy created"

            # Attach policy
            echo -e "\\n\${YELLOW}Attaching policy to user...\${NC}"
            aws iam attach-user-policy \\
              --user-name Quantum-Automation \\
              --policy-arn \${POLICY_ARN}
            echo -e "\${GREEN}\${NC} Policy attached"

            # Create access keys
            echo -e "\\n\${YELLOW}Creating access keys...\${NC}"
            ACCESS_KEY_OUTPUT=$(aws iam create-access-key --user-name Quantum-Automation 2>&1)

            ACCESS_KEY_ID=$(echo "$ACCESS_KEY_OUTPUT" | grep -o '"AccessKeyId": "[^"]*' | cut -d'"' -f4)
            SECRET_ACCESS_KEY=$(echo "$ACCESS_KEY_OUTPUT" | grep -o '"SecretAccessKey": "[^"]*' | cut -d'"' -f4)

            echo -e "\${GREEN}\${NC} Access keys created\\n"

            echo -e "\${GREEN}=== CREDENTIALS (SAVE THESE SECURELY) ===\${NC}\\n"
            echo -e "Access Key ID: \${GREEN}\${ACCESS_KEY_ID}\${NC}"
            echo -e "Secret Access Key: \${GREEN}\${SECRET_ACCESS_KEY}\${NC}\\n"

            echo -e "\${GREEN} Setup complete!\${NC}\\n"
            `;

        const blob = new Blob([scriptContent], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'setup-quantum-automation.sh';
        a.click();
        URL.revokeObjectURL(url);
    }

    function downloadPolicyFile() {
        const policyContent = {
            "Version": "2012-10-17",
            "Statement": [
                {
                    "Sid": "VPCNetworkingPermissions",
                    "Effect": "Allow",
                    "Action": ["ec2:CreateVpc", "ec2:DeleteVpc", "ec2:DescribeVpcs", "ec2:ModifyVpcAttribute", "ec2:CreateSubnet", "ec2:DeleteSubnet", "ec2:DescribeSubnets", "ec2:ModifySubnetAttribute", "ec2:CreateRouteTable", "ec2:DeleteRouteTable", "ec2:DescribeRouteTables", "ec2:AssociateRouteTable", "ec2:DisassociateRouteTable", "ec2:CreateRoute", "ec2:DeleteRoute", "ec2:CreateInternetGateway", "ec2:DeleteInternetGateway", "ec2:AttachInternetGateway", "ec2:DetachInternetGateway", "ec2:DescribeInternetGateways", "ec2:CreateNatGateway", "ec2:DeleteNatGateway", "ec2:DescribeNatGateways", "ec2:AllocateAddress", "ec2:ReleaseAddress", "ec2:DescribeAddresses", "ec2:AssociateAddress", "ec2:DisassociateAddress", "ec2:CreateSecurityGroup", "ec2:DeleteSecurityGroup", "ec2:DescribeSecurityGroups", "ec2:AuthorizeSecurityGroupIngress", "ec2:AuthorizeSecurityGroupEgress", "ec2:RevokeSecurityGroupIngress", "ec2:RevokeSecurityGroupEgress", "ec2:CreateTags", "ec2:DeleteTags", "ec2:DescribeTags", "ec2:DescribeNetworkInterfaces", "ec2:DeleteNetworkInterface"],
                    "Resource": "*"
                },
                {
                    "Sid": "EKSClusterPermissions",
                    "Effect": "Allow",
                    "Action": ["eks:*"],
                    "Resource": "*"
                },
                {
                    "Sid": "IAMPermissions",
                    "Effect": "Allow",
                    "Action": ["iam:CreateRole", "iam:DeleteRole", "iam:GetRole", "iam:ListRoles", "iam:UpdateRole", "iam:AttachRolePolicy", "iam:DetachRolePolicy", "iam:PutRolePolicy", "iam:DeleteRolePolicy", "iam:GetRolePolicy", "iam:ListRolePolicies", "iam:ListAttachedRolePolicies", "iam:CreatePolicy", "iam:DeletePolicy", "iam:GetPolicy", "iam:GetPolicyVersion", "iam:ListPolicies", "iam:ListPolicyVersions", "iam:CreatePolicyVersion", "iam:DeletePolicyVersion", "iam:CreateInstanceProfile", "iam:DeleteInstanceProfile", "iam:GetInstanceProfile", "iam:AddRoleToInstanceProfile", "iam:RemoveRoleFromInstanceProfile", "iam:ListInstanceProfiles", "iam:ListInstanceProfilesForRole", "iam:TagRole", "iam:UntagRole", "iam:TagPolicy", "iam:UntagPolicy", "iam:TagInstanceProfile", "iam:UntagInstanceProfile", "iam:CreateOpenIDConnectProvider", "iam:DeleteOpenIDConnectProvider", "iam:GetOpenIDConnectProvider", "iam:ListOpenIDConnectProviders", "iam:TagOpenIDConnectProvider", "iam:UntagOpenIDConnectProvider", "iam:UpdateAssumeRolePolicy", "iam:PassRole"],
                    "Resource": "*"
                },
                {
                    "Sid": "S3BucketPermissions",
                    "Effect": "Allow",
                    "Action": ["s3:*"],
                    "Resource": "*"
                },
                {
                    "Sid": "DynamoDBPermissions",
                    "Effect": "Allow",
                    "Action": ["dynamodb:*"],
                    "Resource": "*"
                },
                {
                    "Sid": "SecretsManagerPermissions",
                    "Effect": "Allow",
                    "Action": ["secretsmanager:*"],
                    "Resource": "*"
                },
                {
                    "Sid": "CloudWatchPermissions",
                    "Effect": "Allow",
                    "Action": ["logs:*", "cloudwatch:*", "events:*"],
                    "Resource": "*"
                },
                {
                    "Sid": "AutoScalingPermissions",
                    "Effect": "Allow",
                    "Action": ["autoscaling:*"],
                    "Resource": "*"
                },
                {
                    "Sid": "EC2LaunchTemplatePermissions",
                    "Effect": "Allow",
                    "Action": ["ec2:CreateLaunchTemplate", "ec2:CreateLaunchTemplateVersion", "ec2:DeleteLaunchTemplate", "ec2:DeleteLaunchTemplateVersions", "ec2:DescribeLaunchTemplates", "ec2:DescribeLaunchTemplateVersions", "ec2:ModifyLaunchTemplate", "ec2:RunInstances", "ec2:TerminateInstances", "ec2:DescribeInstances", "ec2:DescribeInstanceTypes", "ec2:DescribeImages", "ec2:DescribeKeyPairs", "ec2:CreateKeyPair", "ec2:DeleteKeyPair"],
                    "Resource": "*"
                },
                {
                    "Sid": "LoadBalancerPermissions",
                    "Effect": "Allow",
                    "Action": ["elasticloadbalancing:*"],
                    "Resource": "*"
                },
                {
                    "Sid": "KMSPermissions",
                    "Effect": "Allow",
                    "Action": ["kms:*"],
                    "Resource": "*"
                },
                {
                    "Sid": "ECRPermissions",
                    "Effect": "Allow",
                    "Action": ["ecr:GetAuthorizationToken", "ecr:BatchCheckLayerAvailability", "ecr:GetDownloadUrlForLayer", "ecr:BatchGetImage", "ecr:DescribeRepositories", "ecr:ListImages"],
                    "Resource": "*"
                },
                {
                    "Sid": "CloudFormationPermissions",
                    "Effect": "Allow",
                    "Action": ["cloudformation:*"],
                    "Resource": "*"
                },
                {
                    "Sid": "STSPermissions",
                    "Effect": "Allow",
                    "Action": ["sts:GetCallerIdentity", "sts:AssumeRole"],
                    "Resource": "*"
                }
            ]
        };

        const blob = new Blob([JSON.stringify(policyContent, null, 2)], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'QuantumAutomationPolicy.json';
        a.click();
        URL.revokeObjectURL(url);
    }

    function toggleAutoScroll() {
        const terminal = document.getElementById('terminal');
        terminal.scrollTop = terminal.scrollHeight;
    }

    function clearLogs() {
        document.getElementById('terminal').innerHTML = '';
    }

    function downloadLogs() {
        const terminal = document.getElementById('terminal');
        const logs = terminal.innerText;
        const blob = new Blob([logs], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `deployment-monitoring-logs-${new Date().toISOString()}.txt`;
        a.click();
        URL.revokeObjectURL(url);
    }

    if (viewMode === "list" && !IsViewLogScreen) {
        return (
            <>
                <div className="header-search-input searchplaceholder purchaseSearch d-flex justify-content-end align-items-center gap-2 mb-3">
                    <button className="blue-btn w-auto" onClick={handleAddNew}>
                        + Add Infrastructure Automation
                    </button>
                </div>

                <div className="table-wrapper-main setting-table-main">
                    <div className="profile-common-title"></div>
                    <Table responsive>
                        <thead>
                            <tr>
                                <th>Display Name</th>
                                <th className="text-start">Client Code</th>
                                <th className="text-start">AWS Client ID</th>
                                <th className="text-start">Region</th>
                                <th className="text-start">EKS Version</th>
                                <th className="text-start">Environment</th>
                                <th className="text-start">Created On</th>
                                <th className="">Status</th>
                                <th className="text-end sticky-actions">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {DataLoader ? (
                                <Loader type={LoaderType.TableRow} count={5} nooftd={9} />
                            ) : (
                                <>
                                    {infrastructureList && infrastructureList.length > 0 ? (
                                        infrastructureList.map((item, index) => {
                                            return (
                                                <tr key={item.subscribersinfrastructureautomationid || index}>
                                                    <td className="text-start theme-color-text fw600" title={item.displayname || item.clientname}>
                                                        {item.displayname || item.clientname || "-"}
                                                    </td>
                                                    <td className="text-start">{item.clientname || "-"}</td>
                                                    <td className="text-start">{item.awsclientid || "-"}</td>
                                                    <td className="text-start">{item.awsregion || "-"}</td>
                                                    <td className="text-start">{item.amazoneksversion || "-"}</td>
                                                    <td className="text-start">
                                                        <span className="text-uppercase" style={{ fontSize: "12px", fontWeight: "600", color: "#475569" }}>
                                                            {item.environment || "-"}
                                                        </span>
                                                    </td>
                                                    <td className="text-start">
                                                        {item.createdon
                                                            ? commonservices.getDateInFormatCustom(
                                                                item.createdon,
                                                                null,
                                                                "MM/DD/YYYY"
                                                            )
                                                            : "-"}
                                                    </td>
                                                    <td>
                                                        {commonservices.getStatus(normalizeStatus(item?.status))}
                                                    </td>
                                                    <td className="sticky-actions">
                                                        <div className="all-actions">
                                                            <img
                                                                src={viewaction}
                                                                title="View Details"
                                                                alt="View Details"
                                                                onClick={() => handleViewDetails(item)}
                                                                style={{ cursor: "pointer" }}
                                                            />
                                                            <img
                                                                src={actionLog}
                                                                title="View Logs"
                                                                alt="View Logs"
                                                                onClick={() => handleViewLogs(item)}
                                                                style={{ cursor: "pointer" }}
                                                            />
                                                            <img
                                                                src={deleteaction}
                                                                title="Delete"
                                                                alt="Delete"
                                                                onClick={() => {
                                                                    setSelectedDeleteItem(item);
                                                                    setShowDeleteModal(true);
                                                                }}
                                                                style={{ cursor: "pointer" }}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={9}>
                                                <Nodata title="No Infrastructure Automation found." />
                                            </td>
                                        </tr>
                                    )}
                                </>
                            )}
                        </tbody>
                    </Table>
                </div>

                {showDeleteModal && (
                    <DeleteModal
                        show={showDeleteModal}
                        onHide={() => {
                            setShowDeleteModal(false);
                            setSelectedDeleteItem(null);
                        }}
                        url={API_URL.SUBSCRIBERSINFRASTRUCTUREAUTOMATION.DELETE + `?subscribersinfrastructureautomationid=${selectedDeleteItem?.subscribersinfrastructureautomationid}`}
                        bindlist={GetBySubscriberData}
                    />
                )}
            </>
        );
    }

    return (
        <div className="dashboard-main market-place-page-main market-place-detail-page-main compateline-common account-profile-main">
            <div className="profile-complition-container profile-with-sidebar">
                <div className="top-section-all d-block">
                    <div className="top-section-left d-flex align-items-center justify-content-between">
                        <div className="complete-profile-main-title-wrapper">
                            {
                                IsViewLogScreen ?
                                    <>
                                        <h2>Infrastructure Deployment Monitoring</h2>
                                        <p className="mt-0">Workflow: infrastructure-workflow</p>
                                    </>
                                    :
                                    <>
                                        <h2>{InputModel.subscribersinfrastructureautomationid > 0 ? "Infrastructure Details" : "Add Infrastructure Automation"}</h2>
                                        <p className="mt-0">Quantum Datalytica - Client Infrastructure Management</p>
                                    </>
                            }
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            {
                                IsViewLogScreen ? (
                                    <button className="grey-btn w-auto" onClick={() => { setIsViewLogScreen(false); setViewMode("list"); GetBySubscriberData(); }}>
                                        Back to List
                                    </button>
                                ) : (
                                    <button className="grey-btn w-auto" onClick={() => { setViewMode("list"); GetBySubscriberData(); }}>
                                        Back to List
                                    </button>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="main-page-content compateline-common">
                <div className="profile-complition-container p-0 ps-1 container">
                    <div className="complete-profile-main-content">
                        <div className={`main-section-for-profile-completion ${IsViewLogScreen ? "logscreen" : ""}`}>
                            {
                                IsViewLogScreen ?
                                    <>
                                        <div className="monitoring-content">
                                            <div className="log-viewer-panel">
                                                <div className="panel-header">
                                                    <div className="panel-title">Workflow Logs</div>
                                                    <div className="log-controls">
                                                        <button className="control-btn active" onClick={(e) => toggleAutoScroll()}>Auto-scroll</button>
                                                        <button className="control-btn" onClick={(e) => clearLogs()}>Clear</button>
                                                        <button className="control-btn" onClick={(e) => downloadLogs()}>Download</button>
                                                    </div>
                                                </div>
                                                <div className="terminal" id="terminal">

                                                </div>
                                            </div>


                                            <div className="resource-tracker-panel">
                                                <div className="panel-header">
                                                    <div className="panel-title">Resource Tracker</div>
                                                </div>
                                                <div className="resource-content">

                                                    <div className="status-summary">
                                                        <div className="status-card completed">
                                                            <div className="count" id="completedCount">{ProcessList.filter((d) => d.status === "completed").length}</div>
                                                            <div className="label">Completed</div>
                                                        </div>
                                                        <div className="status-card running">
                                                            <div className="count" id="runningCount">{ProcessList.filter((d) => d.status === "running").length}</div>
                                                            <div className="label">Running</div>
                                                        </div>
                                                        <div className="status-card pending">
                                                            <div className="count" id="pendingCount">{ProcessList.filter((d) => d.status === "pending").length}</div>
                                                            <div className="label">Pending</div>
                                                        </div>
                                                    </div>


                                                    <div className="progress-bar">
                                                        <div className="progress-fill" id="overallProgress" style={{ width: `${ProcessList.filter((d) => d.status === "completed").length * 7.7}%` }}></div>
                                                    </div>
                                                    <div className="progress-text" id="progressText">{ProcessList.filter((d) => d.status === "completed").length} of 13 resources deployed ({Math.round(ProcessList.filter((d) => d.status === "completed").length * 7.7)}%)</div>


                                                    <div className="resource-section">
                                                        <div className="resource-section-title">Completed</div>
                                                        {
                                                            ProcessList.filter((d) => d.status === "completed").map((d) => {
                                                                return (
                                                                    <div className="resource-item">
                                                                        <div className="resource-info">
                                                                            <div className="resource-name">{d.name}</div>
                                                                            <div className="resource-detail">{d.detail}</div>
                                                                        </div>
                                                                        <span className="resource-status status-completed" id={d.id}>Completed</span>
                                                                    </div>)
                                                            })
                                                        }
                                                    </div>


                                                    <div className="resource-section">
                                                        <div className="resource-section-title">Running</div>
                                                        {
                                                            ProcessList.filter((d) => d.status === "running").map((d) => {
                                                                return (
                                                                    <div className="resource-item">
                                                                        <div className="resource-info">
                                                                            <div className="resource-name">{d.name}</div>
                                                                            <div className="resource-detail">{d.detail}</div>
                                                                        </div>
                                                                        <span className="resource-status status-running" id={d.id}>Running</span>
                                                                    </div>)
                                                            })
                                                        }

                                                    </div>


                                                    <div className="resource-section">
                                                        <div className="resource-section-title">Pending</div>
                                                        {
                                                            ProcessList.filter((d) => d.status === "pending").map((d) => {
                                                                return (
                                                                    <div className="resource-item">
                                                                        <div className="resource-info">
                                                                            <div className="resource-name">{d.name}</div>
                                                                            <div className="resource-detail">{d.detail}</div>
                                                                        </div>
                                                                        <span className="resource-status status-pending" id={d.id}>Pending</span>
                                                                    </div>)
                                                            })
                                                        }


                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className="form-wizard">
                                            {
                                                InputModel.subscribersinfrastructureautomationid === 0 &&
                                                <div className="wizard-steps">
                                                    <div className="wizard-progress" id="wizardProgress" style={{ width: GetWizardProgress().per }}></div>
                                                    <div className={`step ${GetWizardProgress().step >= 1 ? "completed" : ""}`} data-step="1">
                                                        <div className="step-number">1</div>
                                                        <div className="step-title">Prerequisites</div>
                                                    </div>
                                                    <div className={`step ${GetWizardProgress().step >= 2 ? "completed" : ""}`} data-step="2">
                                                        <div className="step-number">2</div>
                                                        <div className="step-title">Client Info</div>
                                                    </div>
                                                    <div className={`step ${GetWizardProgress().step >= 3 ? "completed" : ""}`} data-step="3">
                                                        <div className="step-number">3</div>
                                                        <div className="step-title">AWS Creds</div>
                                                    </div>
                                                    <div className={`step ${GetWizardProgress().step >= 4 ? "completed" : ""}`} data-step="4">
                                                        <div className="step-number">4</div>
                                                        <div className="step-title">Versions</div>
                                                    </div>
                                                    <div className={`step ${GetWizardProgress().step >= 5 ? "completed" : ""}`} data-step="5">
                                                        <div className="step-number">5</div>
                                                        <div className="step-title">Review</div>
                                                    </div>
                                                </div>
                                            }


                                            <div className="wizard-content">
                                                {
                                                    ActivePage === "Prerequisites" &&
                                                    <div className="wizard-page">
                                                        <div className="section-title">Prerequisites Checklist</div>
                                                        <div className="prereq-intro">
                                                            <p>Before you begin the infrastructure onboarding process, please ensure you have completed the following prerequisites in your AWS account.</p>
                                                        </div>
                                                        <div className="checklist-container">
                                                            {
                                                                ProjectTermList.AWSPrerequisitesChecklist &&
                                                                ProjectTermList.AWSPrerequisitesChecklist.map((item) => {
                                                                    return (
                                                                        <div className="checklist-item">
                                                                            <input type="checkbox" id={item.projecttermid} className="prereq-checkbox" />
                                                                            <label for={item.projecttermid}>
                                                                                <strong>{item.term}</strong>
                                                                                <span className="checklist-desc">{item.details}</span>
                                                                            </label>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                        <div className="required-permissions-box">
                                                            <div className="permission-header">
                                                                <h3>Quick Setup Guide</h3>
                                                            </div>
                                                            <div className="guide-step">
                                                                <div className="step-badge">Step 1</div>
                                                                <h4>Create IAM User</h4>
                                                                <div className="code-block">
                                                                    <button className="copy-btn" onClick={(e) => copyCode(e.target)}>Copy</button>
                                                                    <code>aws iam create-user --user-name Quantum-Automation</code>
                                                                </div>
                                                            </div>
                                                            <div className="guide-step">
                                                                <div className="step-badge">Step 2</div>
                                                                <h4>Download &amp; Apply Policy</h4>
                                                                <p>Download the complete policy file:</p>
                                                                <button className="btn-download" onClick={(e) => downloadPolicyFile()}>
                                                                    Download QuantumAutomationPolicy.json
                                                                </button>
                                                                <div className="code-block">
                                                                    <button className="copy-btn" onClick={(e) => copyCode(e.target)}>Copy</button>
                                                                    <code>aws iam create-policy --policy-name QuantumAutomationPolicy \
                                                                        --policy-document file://QuantumAutomationPolicy.json</code>
                                                                </div>
                                                            </div>
                                                            <div className="guide-step">
                                                                <div className="step-badge">Step 3</div>
                                                                <h4>Attach Policy to User</h4>
                                                                <div className="code-block">
                                                                    <button className="copy-btn" onClick={(e) => copyCode(e.target)}>Copy</button>
                                                                    <code>aws iam attach-user-policy --user-name Quantum-Automation \
                                                                        --policy-arn arn:aws:iam::YOUR-ACCOUNT-ID:policy/QuantumAutomationPolicy</code>
                                                                </div>
                                                            </div>
                                                            <div className="guide-step">
                                                                <div className="step-badge">Step 4</div>
                                                                <h4>Create Access Keys</h4>
                                                                <div className="code-block">
                                                                    <button className="copy-btn" onClick={(e) => copyCode(e.target)}>Copy</button>
                                                                    <code>aws iam create-access-key --user-name Quantum-Automation</code>
                                                                </div>
                                                                <div className="alert-warning">
                                                                    <strong>Important:</strong> Save the Access Key ID and Secret Access Key immediately - they cannot be retrieved later!
                                                                </div>
                                                            </div>
                                                            <div className="guide-step">
                                                                <div className="step-badge">Step 5</div>
                                                                <h4>Automated Setup Script</h4>
                                                                <p>Alternatively, download and run our automated setup script:</p>
                                                                <button className="btn-download" onClick={(e) => downloadSetupScript()}>
                                                                    Download setup-quantum-automation.sh
                                                                </button>
                                                                <div className="code-block">
                                                                    <button className="copy-btn" onClick={(e) => copyCode(e.target)}>Copy</button>
                                                                    <code>chmod +x setup-quantum-automation.sh
                                                                        ./setup-quantum-automation.sh</code>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="required-permissions-box">
                                                            <div className="permission-header">
                                                                <h3>Required AWS Permissions</h3>
                                                            </div>
                                                            <div className="permission-grid">
                                                                {
                                                                    ProjectTermList.RequiredAWSPermissions &&
                                                                    ProjectTermList.RequiredAWSPermissions.map((item) => {
                                                                        return (
                                                                            <div className="permission-badge">{item.term}</div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="d-flex gap-2 justify-content-end">
                                                            <button className="grey-btn w-auto" onClick={(e) => { setViewMode("list"); GetBySubscriberData(); }}>Cancel</button>
                                                            <button className="blue-btn w-auto" onClick={(e) => fnCheckValidationAndGoNext("Client Info", "Prerequisites")}>Next</button>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    ActivePage === "Client Info" &&
                                                    <div className="wizard-page">
                                                        <div className="section-title">AWS Client Credentials</div>
                                                        <div className="d-flex gap-2">
                                                            <Form.Group className="form-group mb12 w-100">
                                                                <Form.Label className="common-label">
                                                                    Client Code
                                                                    <span className="ms-1 red-color-text">*</span>
                                                                </Form.Label>
                                                                <div className="position-relative">
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder={"Client Code"}
                                                                        className="common-input"
                                                                        disabled={true}
                                                                        value={InputModel.clientname}
                                                                        isInvalid={InputModel?.errors?.clientname}
                                                                    />
                                                                    {InputModel?.errors?.clientname && (
                                                                        <Form.Control.Feedback type="invalid">
                                                                            <span className="error-message-icon">
                                                                                <img
                                                                                    src={infoIcon}
                                                                                    alt="infoIcon"
                                                                                    title={InputModel?.errors?.clientname}
                                                                                />
                                                                            </span>
                                                                        </Form.Control.Feedback>
                                                                    )}
                                                                </div>
                                                            </Form.Group>
                                                            <Form.Group className="form-group mb12 w-100">
                                                                <Form.Label className="common-label">
                                                                    Display Name
                                                                    <span className="ms-1 red-color-text">*</span>
                                                                </Form.Label>
                                                                <div className="position-relative">
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder={"Display Name"}
                                                                        maxLength={167}
                                                                        className="common-input"
                                                                        value={InputModel.displayname}
                                                                        onChange={(e) =>
                                                                            setInputModel({
                                                                                ...InputModel,
                                                                                displayname: e.target.value,
                                                                            })
                                                                        }
                                                                        isInvalid={InputModel?.errors?.displayname}
                                                                    />
                                                                    {InputModel?.errors?.displayname && (
                                                                        <Form.Control.Feedback type="invalid">
                                                                            <span className="error-message-icon">
                                                                                <img
                                                                                    src={infoIcon}
                                                                                    alt="infoIcon"
                                                                                    title={InputModel?.errors?.displayname}
                                                                                />
                                                                            </span>
                                                                        </Form.Control.Feedback>
                                                                    )}
                                                                </div>
                                                            </Form.Group>
                                                        </div>
                                                        <div className="d-flex gap-2">
                                                            <Form.Group className="form-group mb12 w-100">
                                                                <Form.Label className="common-label">
                                                                    AWS Client ID
                                                                    <span className="ms-1 red-color-text">*</span>
                                                                </Form.Label>
                                                                <div className="position-relative">
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder={"AWS Client ID"}
                                                                        className="common-input"
                                                                        value={InputModel.awsclientid}
                                                                        onChange={(e) =>
                                                                            setInputModel({
                                                                                ...InputModel,
                                                                                awsclientid: e.target.value,
                                                                            })
                                                                        }
                                                                        isInvalid={InputModel?.errors?.awsclientid}
                                                                    />
                                                                    {InputModel?.errors?.awsclientid && (
                                                                        <Form.Control.Feedback type="invalid">
                                                                            <span className="error-message-icon">
                                                                                <img
                                                                                    src={infoIcon}
                                                                                    alt="infoIcon"
                                                                                    title={InputModel?.errors?.awsclientid}
                                                                                />
                                                                            </span>
                                                                        </Form.Control.Feedback>
                                                                    )}
                                                                </div>
                                                            </Form.Group>
                                                        </div>

                                                        <div className="d-flex gap-2 justify-content-end">
                                                            <button className="grey-btn w-auto" onClick={(e) => setActivePage("Prerequisites")}>Previous</button>
                                                            <button className="blue-btn w-auto" onClick={(e) => fnCheckValidationAndGoNext("AWS Creds", "Client Info")}>Next</button>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    ActivePage === "AWS Creds" &&
                                                    <div className="wizard-page">
                                                        <div className="section-title">AWS Client Credentials</div>
                                                        <div className="d-flex gap-2">
                                                            <Form.Group className="form-group mb12 w-100">
                                                                <Form.Label className="common-label">
                                                                    AWS Access Key
                                                                    <span className="ms-1 red-color-text">*</span>
                                                                </Form.Label>
                                                                <div className="position-relative">
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder={"AWS Access Key"}
                                                                        className="common-input"
                                                                        value={InputModel.awsaccesskey}
                                                                        onChange={(e) =>
                                                                            setInputModel({
                                                                                ...InputModel,
                                                                                awsaccesskey: e.target.value,
                                                                            })
                                                                        }
                                                                        isInvalid={InputModel?.errors?.awsaccesskey}
                                                                    />
                                                                    {InputModel?.errors?.awsaccesskey && (
                                                                        <Form.Control.Feedback type="invalid">
                                                                            <span className="error-message-icon">
                                                                                <img
                                                                                    src={infoIcon}
                                                                                    alt="infoIcon"
                                                                                    title={InputModel?.errors?.awsaccesskey}
                                                                                />
                                                                            </span>
                                                                        </Form.Control.Feedback>
                                                                    )}
                                                                </div>
                                                            </Form.Group>
                                                        </div>
                                                        <div className="d-flex gap-2">
                                                            <Form.Group className="form-group mb12 w-100">
                                                                <Form.Label className="common-label">
                                                                    AWS Secret Key
                                                                    <span className="ms-1 red-color-text">*</span>
                                                                </Form.Label>
                                                                <div className="position-relative">
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder={"AWS Secret Key"}
                                                                        className="common-input"
                                                                        value={InputModel.awssecretkey}
                                                                        onChange={(e) =>
                                                                            setInputModel({
                                                                                ...InputModel,
                                                                                awssecretkey: e.target.value,
                                                                            })
                                                                        }
                                                                        isInvalid={InputModel?.errors?.awssecretkey}
                                                                    />
                                                                    {InputModel?.errors?.awssecretkey && (
                                                                        <Form.Control.Feedback type="invalid">
                                                                            <span className="error-message-icon">
                                                                                <img
                                                                                    src={infoIcon}
                                                                                    alt="infoIcon"
                                                                                    title={InputModel?.errors?.awssecretkey}
                                                                                />
                                                                            </span>
                                                                        </Form.Control.Feedback>
                                                                    )}
                                                                </div>
                                                            </Form.Group>
                                                        </div>
                                                        <Form.Label className="common-label">
                                                            AWS Region
                                                            <span className="ms-1 red-color-text">*</span>
                                                        </Form.Label>
                                                        <div className={`region-grid ${InputModel?.errors?.awsregion ? "error" : ""}`}>
                                                            {
                                                                ProjectTermList.AWSRegion &&
                                                                ProjectTermList.AWSRegion.map((item) => {
                                                                    return (
                                                                        <div className={`region-card ${item.defaultvalue === InputModel.awsregion ? "selected" : ""}`} onClick={(e) =>
                                                                            setInputModel({
                                                                                ...InputModel,
                                                                                awsregion: item.defaultvalue,
                                                                            })
                                                                        }>
                                                                            <input type="radio" name="region" id={item.projecttermid} checked={item.defaultvalue === InputModel.awsregion} />
                                                                            <div className="region-content">
                                                                                <div className="region-flag"><img src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${item.details}.svg`} alt={item.term} /></div>
                                                                                <div className="region-name">{item.term}</div>
                                                                                <div className="region-code">{item.defaultvalue}</div>
                                                                            </div>
                                                                            <div className="checkmark">
                                                                                <img
                                                                                    src={verified}
                                                                                    alt="verified"
                                                                                    className="verified-email-icon"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })
                                                            }

                                                        </div>
                                                        <div className="d-flex gap-2 justify-content-end">
                                                            <button className="grey-btn w-auto" onClick={(e) => setActivePage("Client Info")}>Previous</button>
                                                            <button className="blue-btn w-auto" onClick={(e) => fnCheckValidationAndGoNext("Versions", "AWS Creds")}>Next</button>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    ActivePage === "Versions" &&
                                                    <div className="wizard-page">
                                                        <div className="section-title">Component Versions</div>
                                                        <div className="d-flex gap-2">
                                                            <Form.Group className="form-group mb12  w-100">
                                                                <Form.Label className="common-label">
                                                                    Amazon EKS (Kubernetes)
                                                                    <span className="ms-1 red-color-text">*</span>
                                                                </Form.Label>
                                                                <div className="position-relative">
                                                                    <Form.Select className="common-select"
                                                                        value={InputModel.amazoneksversion}
                                                                        onChange={(e) =>
                                                                            setInputModel({
                                                                                ...InputModel,
                                                                                amazoneksversion: e.target.value,
                                                                            })
                                                                        }
                                                                        isInvalid={InputModel?.errors?.amazoneksversion}
                                                                    >
                                                                        <option value="">Select Amazon EKS (Kubernetes)</option>
                                                                        {
                                                                            ProjectTermList.AmazonEKSVersion &&
                                                                            ProjectTermList.AmazonEKSVersion.map((item) => {
                                                                                return (
                                                                                    <option value={item.term}>{item.term} {item.details ? `(${item.details})` : ""}</option>
                                                                                )
                                                                            })
                                                                        }
                                                                    </Form.Select>
                                                                    {InputModel?.errors?.amazoneksversion && (
                                                                        <Form.Control.Feedback type="invalid">
                                                                            <span className="error-message-icon">
                                                                                <img
                                                                                    src={infoIcon}
                                                                                    alt="infoIcon"
                                                                                    title={InputModel?.errors?.amazoneksversion}
                                                                                />
                                                                            </span>
                                                                        </Form.Control.Feedback>
                                                                    )}

                                                                </div>
                                                            </Form.Group>
                                                        </div>
                                                        <div className="d-flex gap-2">
                                                            <Form.Group className="form-group mb12  w-100">
                                                                <Form.Label className="common-label">
                                                                    Karpenter (Auto Scaling)
                                                                    <span className="ms-1 red-color-text">*</span>
                                                                </Form.Label>
                                                                <div className="position-relative">
                                                                    <Form.Select className="common-select"
                                                                        value={InputModel.karpenterversion}
                                                                        onChange={(e) =>
                                                                            setInputModel({
                                                                                ...InputModel,
                                                                                karpenterversion: e.target.value,
                                                                            })
                                                                        }
                                                                        isInvalid={InputModel?.errors?.karpenterversion}
                                                                    >
                                                                        <option value="">Select Karpenter (Auto Scaling)</option>
                                                                        {
                                                                            ProjectTermList.KarpenterVersion &&
                                                                            ProjectTermList.KarpenterVersion.map((item) => {
                                                                                return (
                                                                                    <option value={item.term}>{item.term} {item.details ? `(${item.details})` : ""}</option>
                                                                                )
                                                                            })
                                                                        }
                                                                    </Form.Select>
                                                                    {InputModel?.errors?.karpenterversion && (
                                                                        <Form.Control.Feedback type="invalid">
                                                                            <span className="error-message-icon">
                                                                                <img
                                                                                    src={infoIcon}
                                                                                    alt="infoIcon"
                                                                                    title={InputModel?.errors?.karpenterversion}
                                                                                />
                                                                            </span>
                                                                        </Form.Control.Feedback>
                                                                    )}

                                                                </div>
                                                            </Form.Group>
                                                        </div>
                                                        <div className="d-flex gap-2">
                                                            <Form.Group className="form-group mb12  w-100">
                                                                <Form.Label className="common-label">
                                                                    Argo Workflows
                                                                    <span className="ms-1 red-color-text">*</span>
                                                                </Form.Label>
                                                                <div className="position-relative">
                                                                    <Form.Select className="common-select"
                                                                        value={InputModel.argoworkflowsversion}
                                                                        onChange={(e) =>
                                                                            setInputModel({
                                                                                ...InputModel,
                                                                                argoworkflowsversion: e.target.value,
                                                                            })
                                                                        }
                                                                        isInvalid={InputModel?.errors?.argoworkflowsversion}
                                                                    >
                                                                        <option value="">Select Argo Workflows</option>
                                                                        {
                                                                            ProjectTermList.ArgoWorkflowsVersion &&
                                                                            ProjectTermList.ArgoWorkflowsVersion.map((item) => {
                                                                                return (
                                                                                    <option value={item.term}>{item.term} {item.details ? `(${item.details})` : ""}</option>
                                                                                )
                                                                            })
                                                                        }
                                                                    </Form.Select>
                                                                    {InputModel?.errors?.argoworkflowsversion && (
                                                                        <Form.Control.Feedback type="invalid">
                                                                            <span className="error-message-icon">
                                                                                <img
                                                                                    src={infoIcon}
                                                                                    alt="infoIcon"
                                                                                    title={InputModel?.errors?.argoworkflowsversion}
                                                                                />
                                                                            </span>
                                                                        </Form.Control.Feedback>
                                                                    )}
                                                                </div>
                                                            </Form.Group>
                                                        </div>
                                                        <div className="d-flex gap-2 justify-content-end">
                                                            <button className="grey-btn w-auto" onClick={(e) => setActivePage("AWS Creds")}>Previous</button>
                                                            <button className="blue-btn w-auto" onClick={(e) => fnCheckValidationAndGoNext("Review", "Versions")}>Next</button>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    ActivePage === "Review" &&
                                                    <div className="wizard-page">
                                                        <div className="section-title">Review Configuration</div>
                                                        <div className="summary-card">
                                                            <div className="summary-title">Client Information</div>
                                                            <div className="summary-item">
                                                                <span className="summary-label">Client Name:</span>
                                                                <span className="summary-value" id="summary-client-name">{InputModel.clientname}</span>
                                                            </div>
                                                            <div className="summary-item">
                                                                <span className="summary-label">Display Name:</span>
                                                                <span className="summary-value" id="summary-display-name">{InputModel.displayname}</span>
                                                            </div>
                                                            <div className="summary-item">
                                                                <span className="summary-label">AWS Client ID:</span>
                                                                <span className="summary-value" id="summary-client-id">{InputModel.awsclientid}</span>
                                                            </div>
                                                            <div className="summary-item">
                                                                <span className="summary-label">Environment:</span>
                                                                <span className="summary-value" id="summary-environment">{InputModel.environment}</span>
                                                            </div>
                                                        </div>
                                                        <div className="summary-card">
                                                            <div className="summary-title">AWS Credentials</div>
                                                            <div className="summary-item">
                                                                <span className="summary-label">Access Key:</span>
                                                                <span className="summary-value masked" id="summary-access-key">{InputModel.awsaccesskey}</span>
                                                            </div>
                                                            <div className="summary-item">
                                                                <span className="summary-label">Secret Key:</span>
                                                                <span className="summary-value masked" id="summary-secret-key">{InputModel.awssecretkey}</span>
                                                            </div>
                                                            <div className="summary-item">
                                                                <span className="summary-label">Region:</span>
                                                                <span className="summary-value" id="summary-region">{InputModel.awsregion}</span>
                                                            </div>
                                                        </div>
                                                        <div className="summary-card">
                                                            <div className="summary-title">Component Versions</div>
                                                            <div className="summary-item">
                                                                <span className="summary-label">EKS Version:</span>
                                                                <span className="summary-value" id="summary-eks">{InputModel.amazoneksversion}</span>
                                                            </div>
                                                            <div className="summary-item">
                                                                <span className="summary-label">Karpenter Version:</span>
                                                                <span className="summary-value" id="summary-karpenter">{InputModel.karpenterversion}</span>
                                                            </div>
                                                            <div className="summary-item">
                                                                <span className="summary-label">Argo Version:</span>
                                                                <span className="summary-value" id="summary-argo">{InputModel.argoworkflowsversion}</span>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex gap-2 justify-content-end">

                                                            <>
                                                                {
                                                                    InputModel.subscribersinfrastructureautomationid > 0 && InputModel.status.toUpperCase() === "COMPLETED" ?
                                                                        <>
                                                                            <button className="grey-btn w-auto" onClick={() => { setViewMode("list"); GetBySubscriberData(); }}>Back to List</button>
                                                                            {
                                                                                SubmitLoader ?
                                                                                    <button className="blue-btn w-auto"><SubmitLoading /></button>
                                                                                    :
                                                                                    <button className="red-btn w-auto" onClick={(e) => fnOffboardInfrastructure()}>Offboard Infrastructure</button>
                                                                            }
                                                                        </>
                                                                        :
                                                                        <>
                                                                            <button className="grey-btn w-auto" onClick={(e) => setActivePage("Versions")}>Previous</button>
                                                                            {
                                                                                SubmitLoader ?
                                                                                    <button className="blue-btn w-auto"><SubmitLoading /></button>
                                                                                    :
                                                                                    <button className="blue-btn w-auto" onClick={(e) => fnOnboardInfrastructure()}>Onboard Infrastructure</button>
                                                                            }
                                                                        </>
                                                                }
                                                            </>

                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </>
                            }

                        </div>
                    </div>
                </div>
            </div>
            {showDeleteModal && (
                <DeleteModal
                    show={showDeleteModal}
                    onHide={() => {
                        setShowDeleteModal(false);
                        setSelectedDeleteItem(null);
                    }}
                    url={API_URL.SUBSCRIBERSINFRASTRUCTUREAUTOMATION.DELETE + `?subscribersinfrastructureautomationid=${selectedDeleteItem?.subscribersinfrastructureautomationid}`}
                    bindlist={GetBySubscriberData}
                />
            )}
        </div >
    );
};

export default InfrastructureAutomation;
